import { MessagesInterface } from '../../../general/model';

export const Messages = {
  removeError: (message?: string) => ({
    title: `We have a problem deleting some items`,
    message,
  }),
} as MessagesInterface;

export type SharedLinksRemoverShape = {
  bulkJobID: null | string;
  isOpen: boolean;
  inProgress: boolean;
  shareIDs: string[];
};
export const initialState: SharedLinksRemoverShape = {
  bulkJobID: null,
  isOpen: false,
  inProgress: false,
  shareIDs: [],
};
